import {
  reploComponentSchema,
  reploComponentSchemaBasePartial,
} from "schemas/component";
import * as z from "zod";

const conditions = [
  "screen.pageY",
  "element.offsetY",
  "interaction.clickEvent",
  "interaction.hover",
  "state.action.loading",
  "page.hashmark",
  "state.product.selectedVariant",
  "state.product.currentVariantIsOnSale",
  "state.product.selectedOptionValues",
  "state.product.isOptionValueUnavailable",
  "state.product.isVariantUnavailable",
  "state.product.selectedVariantUnavailable",
  "state.temporaryCart.numberOfItems",
  "state.temporaryCart.containsVariant",
  "state.collapsibleV2.isOpen",
  "state.product.noProductVariantSelected",
  "state.tabsBlock.isCurrentTab",
  "state.tabsV2Block.isCurrentTab",
  "state.group.isCurrentItemActive",
  "state.group.isFirstItemActive",
  "state.group.isLastItemActive",
  "product_variant_is_on_sale",
  "state.product.quantity",
  "state.product.selectedSellingPlan",
  "state.product.templateProductEquals",
  "state.tooltip.isOpen",
  "state.beforeAfterSlider.isDragging",
  "state.product.selectedVariantEquals",
  "state.product.selectedProductEquals",
  "state.selectionList.isItemSelected",
] as const;
export const conditionFieldSchema = z
  .enum(conditions)
  .describe("ConditionField");

const operatorSchema = z.enum([
  "all",
  "gt",
  "gte",
  "lt",
  "lte",
  "eq",
  "neq",
  "includes",
  "excludes",
]);

const conditionStatementSchema = z.object({
  id: z.string(),
  field: conditionFieldSchema,
  operator: operatorSchema.nullish(),
  value: z.unknown().optional(),
});

export const reploVariantSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    query: z
      .object({
        type: z.string().optional(),
        operator: z.string().optional(),
        statements: z.array(conditionStatementSchema),
      })
      .nullable(),
    componentOverrides: z
      .record(z.string(), reploComponentSchemaBasePartial)
      .nullish(),
  })
  .describe("ReploState");

export const reploSymbolSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    storeId: z.string(),
    component: reploComponentSchema,
    variants: z.array(reploVariantSchema),
    createdAt: z.date().nullish(),
  })
  .describe("ReploSymbol");
